import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { Router, RouterModule } from '@angular/router'
import { AuthService } from '@auth/services/auth.service'
import { NbButtonModule, NbCardModule } from '@nebular/theme'
/**
 * Main component for user and organization settings
 */
@Component({
  selector: 'ngx-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.scss'],
  standalone: true,
  imports: [CommonModule, NbCardModule, MatIconModule, NbButtonModule, RouterModule]
})
export class SettingsPageComponent {
  /**
   * Creates the component and injects it's dependencies
   * @param router Router
   * @param auth AuthService
   */
  constructor(private router: Router, public auth: AuthService) {}

  /**
   * Get's the active route
   * @returns string
   */
  activeRoute(): string {
    return this.router.url.replace(/.*\//, '')
  }
  /**
   * Navigates to workspaces list
   */
  navigateBack() {
    this.router.navigateByUrl('workspaces/list')
  }
}
